import { experience } from '../constants/Experience';
import styles from './styles/Experience.module.css';

const Experience = () => {
    return (
        <div className={styles.experienceContainer} >

            {experience.map((item, index) => 
                <ExperienceItem
                    key={index}
                    from={item.from}
                    to={item.to}
                    title={item.title}
                    company={item.company}
                    details={item.details}
                />   
            )}

        </div>
    )
}

const ExperienceItem = ({ from, to, title, company, details, tags }) => {
    return (
        <div className={styles.experienceItemContainer}>
            <div className={styles.dateFromDateTo}>
                {`${from} - ${to}`}
            </div>
            <div className={styles.titleAndDetailsContainer}>
                <div className={styles.titleAndCompany}>
                    {`${title} · ${company}`}
                </div>
                <div className={styles.details}>
                    <ul>
                        {details && details.map((detail, index) => (
                            <li key={index} className={styles.detailItem}>
                                {detail}
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        </div>
    )
}


export default Experience;